import {Outlet} from "react-router-dom";
import React from "react";
import prependContexts from "../hoc/PrependContext";
import {DataContextProvider} from "../context/DataContext";

const MainLayout = () => {
    return (
        <>
            <DataContextProvider>
                <Outlet />
            </DataContextProvider>

        </>
    );
}
export default function MainLayoutWithContexts() {
    let Node;
    Node = prependContexts(MainLayout);
    return <Node />;
}